import {
  IShopAddressInput,
  IShopSubscriber,
  IShopSubscriberDeclarationMutationVariables,
} from '@x/ecommerce/shop-client';

export class SubscriberFetch {
  static readonly type = '[Subscriber] Fetch';
  constructor(public subscriberId: number) {}
}

export class RefreshSubscriber {
  static readonly type = '[Subscriber] Refetch';
}

export class SubscriberUpdate {
  static readonly type = '[Subscriber] Update';
}

export class SubscriberUpdateSet {
  static readonly type = '[Subscriber] Update Set';
  constructor(public subscriber: IShopSubscriber) {}
}

export class SubscriberUpdatePaymentMethod {
  static readonly type = '[Subscriber] Update Payment Method';
  constructor(public userPaymentMethodId: number) {}
}

export class SubscriberUpdateAddress {
  static readonly type = '[Subscriber] Update Address';
  constructor(public addressInput?: IShopAddressInput) {}
}

export class SubscriberActivate {
  static readonly type = '[Subscriber] Activate';
}

export class SubscriberReset {
  static readonly type = '[Subscriber] Reset';
}

export class SubscriberPaymentMethods {
  static readonly type = '[Subscriber] Payment Methods';
}

export class SubscriberTermsUrl {
  static readonly type = '[Subscriber] Terms Url';
}

export class SubscriberPause {
  static readonly type = '[Subscriber] Pause';
}

export class SubscriberFetchChannelContext {
  static readonly type = '[Subscriber] Fetch channel context';
}

export class SubscriberUpdateDeclaration {
  static readonly type = '[Subscriber] Update subscriber required agreements';
  constructor(
    public args: Omit<IShopSubscriberDeclarationMutationVariables['input'], 'subscriberId'>,
  ) {}
}
